export const generateUniqueMessageId = (ContactId, messageId) => {
  try {
    const hasContactId = Boolean(ContactId);
    const hasCdrInfo =
      (hasContactId && Boolean(ContactId.idatendimento)) ||
      ContactId.idatendimento === 0;
    if (!hasCdrInfo) return messageId;
    return `${ContactId.idatendimento}-${messageId}`;
  } catch (error) {
    console.log("generateUniqueMessageId ERROR: ", error);
    return messageId;
  }
};
